var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6142 58.5051H29.0681H17.775C16.1323 58.5051 14.9414 57.7249 14.9414 56.6571C14.9414 52.3042 15.3931 49.1831 16.3787 46.8424C17.6518 43.7214 19.8693 42.0377 22.9493 41.8323C25.7007 37.1919 31.3678 34.0298 36.9528 34.0298H48.6977C53.6666 34.0298 57.2804 37.2329 59.9087 39.5737C61.1817 40.6825 62.4548 41.8323 63.1529 41.8323H73.5426C78.2241 41.8323 82.1254 45.4051 82.5771 50.0045C83.6448 50.0866 85 50.4151 85 51.565V56.6571C85 57.7249 83.8091 58.5051 82.2075 58.5051H69.7645H31.6142Z",
    fill: "#838EAE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0647 53.289C15.1058 52.5909 15.1879 51.9749 15.27 51.3589H18.7196C19.2534 51.3589 19.7052 51.7695 19.7052 52.3034C19.7052 52.8373 19.2534 53.289 18.7196 53.289H15.0647Z",
    fill: "#445174"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.1139 48.1975H43.8928V38.4238H50.9972C51.2436 38.4238 51.4489 38.506 51.6543 38.6702L60.7298 46.5138C61.0584 46.7602 61.1405 47.1709 61.0173 47.5405C60.8941 47.9511 60.5245 48.1975 60.1139 48.1975ZM41.9627 48.1975H26.9736C26.604 48.1975 26.2755 47.9511 26.1112 47.6226C25.947 47.2941 26.0291 46.8834 26.2755 46.596L33.0924 38.7524C33.2978 38.547 33.5442 38.4238 33.8316 38.4238H41.9627V48.1975Z",
    fill: "#E4E6EC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3409 66.5127C25.9469 66.5127 22.3741 62.94 22.3741 58.5459C22.3741 54.1518 25.9469 50.5791 30.3409 50.5791C34.735 50.5791 38.3077 54.1518 38.3077 58.5459C38.3077 62.94 34.735 66.5127 30.3409 66.5127Z",
    fill: "#AF8EFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.2428 66.5128C66.8487 66.5128 63.276 62.94 63.276 58.546C63.276 54.1519 66.8487 50.5381 71.2428 50.5381C75.6369 50.5381 79.2096 54.1519 79.2096 58.546C79.2096 62.94 75.6369 66.5128 71.2428 66.5128Z",
    fill: "#AF8EFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.341 62.4882C28.1645 62.4882 26.3987 60.7223 26.3987 58.5459C26.3987 56.3694 28.1645 54.6035 30.341 54.6035C32.5175 54.6035 34.2834 56.3694 34.2834 58.5459C34.2834 60.7223 32.5175 62.4882 30.341 62.4882Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.5771 67.9711H17.4054C16.8715 67.9711 16.4198 67.5605 16.4198 67.0266C16.4198 66.4927 16.8715 66.041 17.4054 66.041H82.5771C83.111 66.041 83.5216 66.4927 83.5216 67.0266C83.5216 67.5605 83.111 67.9711 82.5771 67.9711Z",
    fill: "#394461"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.2429 62.4882C69.0664 62.4882 67.3005 60.7223 67.3005 58.5459C67.3005 56.3694 69.0664 54.6035 71.2429 54.6035C73.4194 54.6035 75.1852 56.3694 75.1852 58.5459C75.1852 60.7223 73.4194 62.4882 71.2429 62.4882Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.2372 54.4399H40.197C39.7042 54.4399 39.2524 54.0292 39.2524 53.4953C39.2524 52.9615 39.7042 52.5098 40.197 52.5098H60.2372C60.771 52.5098 61.1817 52.9615 61.1817 53.4953C61.1817 54.0292 60.771 54.4399 60.2372 54.4399Z",
    fill: "#445174"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarNew);
export default __webpack_public_path__ + "static/media/CarNew.401f8686ed8b1f85f22d1547313a78c1.svg";
export { ForwardRef as ReactComponent };